import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import Search from './sub/search'



const TransportList = () => {
    const navigate = useNavigate();
  
  const alert = useRef();
  const alertmodal = useRef();
  const editjob = useRef();
  const setError = (message) => alert.current.showerror(message);
  const [transportJobList, setTransportJobList] = useState([]);
  const [customers, SetCustomers] = useState([]);
  const [selectedrow, setSelectedRow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [resultData, setResultData] = useState({
    columns: [
      { label: "วันที่", field: 'jobdate', sort: false },
      { label: "ใบงาน", field: 'name', sort: false },
      { label: "สถานะ", field: 'status', sort: false },
      { label: "ผู้ว่าจ้าง", field: 'customername', sort: false },
      { label: "งาน", field: 'jobname', sort: false },
      { label: "สถานที่รับ", field: 'pickuplocation', sort: false },
      { label: "ปลายทาง", field: 'destination', sort: false },
      { label: "ขนาด", field: 'boxsize', sort: false },
      { label: "เบอร์ตู้", field: 'boxno', sort: false },
      { label: "จ่าย", field: 'paidby', sort: false },
      { label: "คนรถ", field: 'driver', sort: false },
      { label: "ทะเบียน", field: 'lcplate', sort: false },
      { label: "ผู้ลงข้อมูล", field: 'create_name', sort: false },
      { label: "", field: 'action', sort: false }

    ],
    rows: []
  });
  const [datatableKey, setDatatableKey] = useState(0); // Add a key state for MDBDatatable
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const editRow = (row) => {
    row.jobdate = moment(row.jobdateobj).format("DD/MM/YYYY");
    setBasicModal(true);
    setSelectedRow({ row });

  }
  const endEdit = async () => {


    var editeddata = editjob.current.getResult()
    selectedrow.row = Object.assign(selectedrow.row, editeddata);
    selectedrow.row.jobdateobj = moment(selectedrow.row.jobdate, "DD/MM/YYYY");
    saveData();


  }

  const saveData = async (e) => {


    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransport`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transport: null, transportJobList: [selectedrow.row] }),
      });
      const data = await response.json();
      if (response.ok) {

        alert.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว");
        var item = transportJobList;

        setTransportJobList([...item]);
        setBasicModal(false);
      } else {

        alertmodal.current.showerror(data.message);
      }
    } catch (err) {
      alertmodal.current.showerror('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }

  }

  const deleteRow = async (transportJob) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deleteTransportJobList`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportJob }),

      });
      const data = await response.json();
      if (response.ok) {
        var item = transportJobList.filter(el => el !== transportJob);

        setTransportJobList([...item]);
        alert.current.showmessage(data.message);
      } else {

        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }


  }
  const fetchTransportJobList = async (dateFrom, dateTo,search) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportJobList`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo,search }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transportJobList);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };

  const generateTree = (item) => {
    var main = item.map((row) => {
      return {
        ...row,
        jobdate: moment(row.jobdateobj).format("DD/MM/YYYY"),
        action: (
          <>
              <> <MDBBtn outline size='sm' floating className='call-btn' color='info' onClick={() => window.open('/Print/Transport/' + row.name , '_blank')}>
              <MDBIcon icon='print' />
            </MDBBtn>
            </>
            {row.statusid != 3 &&
              <> <MDBBtn outline size='sm' floating className='call-btn' onClick={() => editRow(row)}>
                <MDBIcon icon='pen' />
              </MDBBtn>
                <MDBPopconfirm

                  onConfirm={() => deleteRow(row)}
                  placement='bottom'
                  btnChildren={<MDBIcon icon='trash' />}
                  btnClassName='ms-2 btn-sm btn-danger btn-floating'
                  cancelBtnText='ยกเลิก'
                  confirmBtnText='ตกลง'
                  confirmBtnClasses='btn-danger'
                  cancelBtnClasses='btn btn-outline-primary'
                >
                  <MDBPopconfirmMessage>ยืนยันที่จะลบ?</MDBPopconfirmMessage>
                </MDBPopconfirm></>
            }
            {row.statusid == 3 &&
              <> <MDBBtn outline size='sm' floating className='call-btn' onClick={() => editRow(row)}>
                <MDBIcon icon='eye' />
              </MDBBtn>
              </>
            }
        
            
          </>
        )

      }
    });



    var _resultData = {

      rows: main
    }

    _resultData.columns = [...resultData.columns];

    setResultData(_resultData);
    setDatatableKey((prevKey) => prevKey + 1);

  }
  useEffect(() => {
    if (transportJobList.length > 0)
      generateTree(transportJobList);

  }, [transportJobList]);

  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }
    Helper.getCustomers(SetCustomers, setError);

    fetchTransportJobList(moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"));
  }, []);

  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='10'>
                  <h4>รายการงานขนส่ง</h4>
                </MDBCol>

              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <Search search={fetchTransportJobList} />
              <hr className="hr" />
              <div className="mt-2">
                <MDBDatatable key={datatableKey} hover data={resultData} rowsText="แสดง" noFoundMessage="ไม่มีข้อมูล" ofText="จาก" allText="ทั้งหมด" />
              </div>


            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>


      <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
        <MDBModalDialog centered size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>แก้ไขข้อมูลงาน</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <Alert ref={alertmodal} />
              {selectedrow && <JobDetail setError={setError} customers={customers} ref={editjob} job={selectedrow.row} mode="edit" disabledCustomer={true} />}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                ปิด
              </MDBBtn>
              {selectedrow && selectedrow.row.statusid != 3 && <MDBBtn onClick={endEdit} disabled={isLoading}>บันทึก</MDBBtn>}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  </>);
};

export default TransportList;
